import { TicketNotesController } from './ticketNotes.controller';
import template from './ticketNotes.html';

export const ticketNotesComponent = {
  name: 'ticketNotes',
  restrict: 'E',
  template,
  controller: TicketNotesController,
  controllerAs: 'vm',
  bindings: {
    notes: '=',
    newNote: '<',
    ticketId: '<',
    ticketType: '<',
    pending: '&'
  }
};
